import { Theme } from '@mui/material/styles/createTheme';
import { ActivityMessage } from 'src/components/ActivityList/activity-list-item';
import { BoldText } from 'src/components/ActivityList/styled/bold-text';
import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';

export const buildClientEmailMessage = (activity: ActivityFeed): ActivityMessage[] => {
  const actorName = activity.actor?.name?.trim() || '<Platform User>';
  const emailChange = activity.changes.find((c) => c.name === 'Email');
  if (!emailChange) {
    return [];
  }

  switch (activity.activityType) {
    case 'create': {
      return [
        {
          id: activity.id,
          icon: 'mail',
          color: (theme: Theme) => theme.palette.custom.OV.sys.primary,
          message: `${actorName} added email: ${emailChange?.value}`,
          timestamp: activity.timestamp,
        },
      ];
    }
    case 'update':
      return activity.changes
        .filter(({ value, previousValue }) => value !== previousValue)
        .map(({ name, value, previousValue }) => {
          if (!!value && !!previousValue) {
            return {
              id: `${activity.id}-${name}`,
              icon: 'edit_attributes',
              color: (theme: Theme) => theme.palette.custom.OV.sys.tertiary,
              message: (
                <>
                  {actorName} changed the <BoldText>{name}</BoldText> from{' '}
                  <BoldText>&quot;{previousValue}&quot;</BoldText> to{' '}
                  <BoldText>&quot;{value}&quot;</BoldText>
                </>
              ),
              timestamp: activity.timestamp,
            };
          } else if (!!value && !previousValue) {
            return {
              id: `${activity.id}-${name}`,
              icon: 'edit_attributes',
              color: (theme: Theme) => theme.palette.custom.OV.sys.tertiary,
              message: (
                <>
                  {actorName} added the {name} <BoldText>&quot;{value}&quot;</BoldText>
                </>
              ),
              timestamp: activity.timestamp,
            };
          }
          return null;
        })
        .filter((value) => !!value);
    case 'delete': {
      return [
        {
          id: activity.id,
          icon: 'mail_off',
          color: (theme: Theme) => theme.palette.custom.OV.sys.error,
          message: `${actorName} deleted email: ${emailChange.previousValue}`,
          timestamp: activity.timestamp,
        },
      ];
    }
    default:
      return [];
  }
};
